import { ClipboardCheckIcon, FolderOpenIcon, SigmaIcon, TargetIcon, ZapIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  benefit: string;
  value: string;
  icon: LucideIcon;
  wide?: boolean;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Banco de 150 Actividades y Prácticas de Energías Renovables',
    description:
      '150 propuestas listas para utilizar o adaptar en clases sobre energía solar, eólica, hidráulica, biomasa, almacenamiento, eficiencia energética y transición energética. Organizadas por nivel de dificultad.',
    benefit: 'Materiales ya pensados para el aula: ahorra horas en cada trimestre.',
    value: 'USD 14',
    icon: FolderOpenIcon,
  },
  {
    number: '02',
    title: '100 Problemas, Cálculos y Ejercicios Resueltos',
    description:
      'Ejercicios progresivos sobre potencia, energía, consumo, generación, rendimiento, dimensionamiento de paneles solares, cálculo de baterías, autonomía, viento y aprovechamientos hidroenergéticos. Cada ejercicio acompañado de su procedimiento y resolución completa.',
    benefit: 'Tus alumnos aprenden viendo cómo se resuelve realmente.',
    value: 'USD 14',
    icon: SigmaIcon,
  },
  {
    number: '03',
    title: 'Kit Completo de Evaluaciones de Energías Renovables',
    description:
      'Evaluaciones diagnósticas, actividades de seguimiento, preguntas de opción múltiple, verdadero/falso, situaciones problemáticas, evaluaciones integradoras, rúbricas y criterios de evaluación. Todo incluido directamente dentro del PDF.',
    benefit: 'Nunca más construyas un examen desde cero bajo presión.',
    value: 'USD 14',
    icon: ClipboardCheckIcon,
  },
  {
    number: '04',
    title: '50 Proyectos de Energías Renovables para el Aula',
    description:
      '50 propuestas de proyectos educativos y técnicos con objetivos claros, materiales sugeridos, etapas de desarrollo, consignas específicas y criterios de evaluación. Desde proyectos introductorios hasta propuestas integradoras complejas.',
    benefit: 'Tus alumnos cierran el año con proyectos reales en sus territorios.',
    value: 'USD 14',
    icon: TargetIcon,
  },
  {
    number: '05',
    title: 'Guía Visual de Tecnologías y Componentes de Energías Renovables',
    description:
      'Material de consulta sobre paneles solares, inversores, controladores, baterías, aerogeneradores, turbinas, biodigestores y otros componentes. Incluye esquemas explicativos, tablas comparativas, conceptos clave y criterios básicos de funcionamiento.',
    benefit: 'Proyéctalo en clase y tus alumnos entienden de inmediato cómo funciona cada pieza.',
    value: 'USD 14',
    icon: ZapIcon,
    wide: true,
  },
];
